export default __webpack_public_path__ + "static/media/Calculation.4cba50c1.svg";